import React from 'react'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { UsageTrend } from '@/types/dashboard'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface RequestsChartProps {
  data: UsageTrend[]
  title?: string
}

const RequestsChart: React.FC<RequestsChartProps> = ({ data, title = 'Requisições API' }) => {
  const chartData = {
    labels: data.map(item => item.date)?.reverse(),
    datasets: [
      {
        label: 'Requisições API',
        data: data.map(item => item.requests)?.reverse(),
        backgroundColor: 'rgb(255, 105, 180)',
        borderRadius: 4
      }
    ]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: !!title,
        text: title
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    animation: {
      duration: 2000
    }
  }

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 h-[400px] transition-all duration-200 hover:shadow-md">
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default RequestsChart
